<script setup lang="ts">
import logo from "@client/assets/img/logo.webp";
import { useTimer } from "@client/composables/timer";
const upTimer = useTimer({ mins: 30, secs: 30, direction: "up" });
upTimer.start();
</script>

<template>
	<Transition name="find-match-toast" appear>
		<div
			class="tw:flex tw:flex-col tw:gap-2 tw:w-full tw:flex-1 tw:p-4 tw:font-bold tw:grow-0
				tw:[background:linear-gradient(90deg,#aaa_0%,#4b4b4b_100%)]">
			<p
				class="tw:[text-shadow:2px_2px_#000] tw:text-[max(0.7rem,1vmax)] tw:truncate tw:text-[#d9f237]">
				FINDING MATCH
			</p>
			<div class="tw:w-full tw:items-center tw:flex">
				<div
					class="tw:flex tw:gap-3 tw:items-center tw:justify-center tw:flex-wrap tw:w-full">
					<img
						alt="logo"
						:src="logo"
						class="tw:h-[max(25px,3vmax)] animation-pulse tw:flex-shrink-0" />
					<div
						class="tw:flex tw:flex-col tw:w-[55%] tw:text-[max(0.6rem,0.8vmax)]
							tw:[text-shadow:1px_1px_rgba(0,0,0,0.8)]">
						<p class="tw:font-bold tw:truncate">
							<span
								class="tw:after:content-[attr(default)] tw:max-[1170px]:after:content-[attr(acronym)]"
								default="ELAPSED: "
								acronym="ET: " />
							<span>{{ upTimer.time }}</span>
						</p>
						<p class="tw:text-[#CFCFAE] tw:truncate">
							<span
								class="tw:after:content-[attr(default)] tw:max-[1170px]:after:content-[attr(acronym)]"
								default="ESTIMATED: "
								acronym="EST: " />
							<span>1:30</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</Transition>
</template>
<style scoped>
.find-match-toast-enter-active,
.find-match-toast-leave-active {
	transition: all 1s ease;
}

.find-match-toast-enter-from,
.find-match-toast-leave-to {
	opacity: 0;
	transform: translateX(100px);
}

.animation-pulse {
	animation: pulse 2s infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.8);
		filter: drop-shadow(0 0 rgb(160, 0, 210));
	}
	70% {
		transform: scale(1);
		filter: drop-shadow(0px 8px 1mm rgba(229, 62, 62, 0));
	}
	100% {
		transform: scale(0.8);
	}
}
</style>
